import { useMutation } from "@tanstack/react-query";

import { api } from "@/api/client";
import type {
  DashboardFeedbackInput,
  DashboardFeedbackResponse,
} from "@/api/types";

export const useSubmitDashboardFeedback = () =>
  useMutation({
    mutationFn: (input: DashboardFeedbackInput) =>
      api.post<DashboardFeedbackResponse>("/admin/feedback", input),
  });
